import { render, staticRenderFns } from "./score.vue?vue&type=template&id=39c542f4&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"
import style0 from "./score.vue?vue&type=style&index=0&id=39c542f4&prod&scoped=scoped&lang=css"
import style1 from "./score.vue?vue&type=style&index=1&id=39c542f4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c542f4",
  null
  
)

export default component.exports